
(function () {
    var BREAKPOINT = 980;

    function assignKlaviyoBISTrigger() {
        var desktopTrigger = document.querySelector(
        '.product__section-details .klaviyo-bis-trigger'
        );
        var stickyTrigger = document.querySelector(
        '#dx-sticky-atc .klaviyo-bis-trigger'
        );

        if (!desktopTrigger || !stickyTrigger) return;

        if (window.innerWidth <= BREAKPOINT) {
        stickyTrigger.classList.add('klaviyo-bis-trigger');
        desktopTrigger.classList.remove('klaviyo-bis-trigger');
        } else {
        desktopTrigger.classList.add('klaviyo-bis-trigger');
        stickyTrigger.classList.remove('klaviyo-bis-trigger');
        }
    }

    assignKlaviyoBISTrigger();

    var resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(assignKlaviyoBISTrigger, 150);
    });
})();